<template>
<layout-crumb :opts="[{label: task.siteName}, {label: $route.meta.label}]">
  <section class="selector-wrapper">
    <section class="selector-body">
      <section
        v-for="(photos, photoWrappersIndex) in photoWrappers"
        :key="photoWrappersIndex"
        :class="`flex-wrapper-${photoWrappers.length}`"
      >
        <section
          v-for="(photo, photoIndex) in photos"
          :key="photoIndex"
          class="photo"
        >
          <div class="photo-body">
            <data-image
              :img-host="IMAGE_HOST"
              :img-obj="photo.pathname ? photo : null"
              file-prop="pathname"
              style="width:100%;height:100%;border:0;border-radius:0;"
              @take-photo="onTakePhoto(photo, ...arguments)"
              @img-click="onImgClick"
            />
          </div>
          <div class="photo-label">{{photo.label}}</div>
        </section>
      </section>
    </section>

    <section class="selector-footer">
      <button class="back-btn" @click="onPreStepClick">返回测量器具</button>
      <Abort />
      <button class="next-btn" @click="onNextStepClick">开始检查</button>
    </section>
  </section>

  <van-action-sheet
    v-model="imgOptsVisible"
    :actions="imageActions"
    cancel-text="取消"
    @select="onImageOptClick"
  />

  <van-overlay :show="overlayVisible">
    <van-loading type="spinner" />
  </van-overlay>
</layout-crumb>
</template>

<script>
import {mapGetters} from 'vuex'
import {Toast, ImagePreview} from 'vant'

const IMAGE_HOST = process.env.IMAGE_HOST

const PHOTO_TYPE_MAP = {
  0: 'fieldPhotoPath',
  1: 'fieldPhotoEastPath',
  2: 'fieldPhotoWestPath',
  3: 'fieldPhotoSouthPath',
  4: 'fieldPhotoNorthPath'
}

export default {
  name: 'index',
  routeInfo: {
    label: '站房环境照片'
  },
  data () {
    return {
      overlayVisible: false,
      imgOptsVisible: false,
      photoWrappers: [
        [{
          taskId: null,
          type: 4,
          label: '站房北面照片',
          pathname: null,
          fileStr: null
        }], [{
          taskId: null,
          type: 2,
          label: '站房西面照片',
          pathname: null,
          fileStr: null
        }, {
          taskId: null,
          type: 0,
          label: '现场情况照片',
          pathname: null,
          fileStr: null
        }, {
          taskId: null,
          type: 1,
          label: '站房东面照片',
          pathname: null,
          fileStr: null
        }], [{
          taskId: null,
          type: 3,
          label: '站房南面照片',
          pathname: null,
          fileStr: null
        }]
      ]
    }
  },
  computed: {
    IMAGE_HOST: () => IMAGE_HOST,
    imageActions () {
      return [{
        value: 'PREVIEW',
        name: '预览图片',
        callback: this.previewImage
      }, {
        value: 'DELETE',
        name: '清除图片',
        callback: this.deleteImage
      }]
    },
    ...mapGetters({
      task: 'Task/task',
      orgId: 'Profile/orgId'
    })
  },
  methods: {
    onPreStepClick () {
      this.$router.replace({
        name: 'MeasureInstrumentSelector'
      })
    },
    onNextStepClick () {
      let photos = this.photoWrappers.flat()

      if (photos.some(photo => !photo.pathname)) {
        return Toast('还有站房照片未上传')
      }

      this.$router.replace({
        name: 'Grade'
      })
    },
    onTakePhoto (photo, base64) {
      this.overlayVisible = true

      this.$api.Task.uploadSitePhoto({
        taskId: this.task.id,
        photoType: photo.type,
        fileStr: base64.replace(/^data:image\/jpeg;base64,/, '')
      }).then(data => {
        photo.pathname = data
      }).catch(console.error).finally(() => {
        this.overlayVisible = false
      })
    },
    onImgClick (photo) {
      this.currentPhoto = photo
      this.imgOptsVisible = true
    },
    previewImage () {
      let {currentPhoto} = this

      if (!currentPhoto) {
        return
      }

      let photos = this.photoWrappers.flat().filter(photo => photo.pathname)
      let index = photos.indexOf(currentPhoto)

      if (index > -1) {
        ImagePreview({
          images: photos.map(photo => `${IMAGE_HOST}${photo.pathname}`),
          startPosition: index
        })
      }
    },
    deleteImage () {
      let {currentPhoto} = this

      if (!currentPhoto) {
        return
      }

      currentPhoto.pathname = null
    },
    onImageOptClick () {
      this.imgOptsVisible = false
    }
  },
  created () {
    let task = this.task
    this.photoWrappers.forEach(photos => {
      photos.forEach(photo => {
        photo.pathname = task[PHOTO_TYPE_MAP[photo.type]] || null
      })
    })
  }
}
</script>

<style lang="scss" scoped>
.selector-wrapper {
  .selector-body {
    display: flex;
    flex-direction: column;
    padding: 1rem;
    border-bottom: 1px solid #cfd0d3;
    background-color: #f7f8fa;

    > * {
      display: flex;
      align-items: center;
    }

    > .flex-wrapper-1 {
      flex: 1;
      justify-content: center;
    }

    > .flex-wrapper-3 {
      flex: 1;
      justify-content: space-around;
    }

    .photo {
      $LABEL-HEIGHT: 30px;

      position: relative;
      display: flex;
      width: 30%;
      height: 75%;
      padding-bottom: $LABEL-HEIGHT;
      border: 1px solid #cfd0d3;
      background-color: #fff;
      box-shadow: 0 0 22px 2px rgba(0, 0, 0, .15);

      > .photo-body {
        width: 100%;
        height: 100%;
        border-bottom: 1px solid #cfd0d3;
      }

      > .photo-label {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: $LABEL-HEIGHT;
        line-height: $LABEL-HEIGHT;
        text-align: center;
        background-color: #f7f8fa;
      }
    }
  }
}

.van-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/views/06SiteEnvPhoto/index.vue